<template>
  <v-carousel
    dark
    class="carousel"
    interval="700000"
    hide-controls
    :height="heightImage"
  >
    <v-carousel-item
      v-for="(item, i) in this.carousel"
      :key="i"
      :src="item.main_image"
      style="cursor: pointer"
      @click="goToShowPost(item)"
    >
      <img src="@/assets/protagonistas.png" :style="styleProtagonistImg" />
    </v-carousel-item>
  </v-carousel>
</template>
<script>
import { mapActions, mapState } from "vuex";

export default {
  data: () => ({}),
  beforeMount() {
    if (!this.carousel.length) {
      this.fetchProtagonistsHome();
    }
  },
  methods: {
    ...mapActions("protagonists", ["fetchProtagonistsHome"]),
    goToShowPost(post) {
      this.$router
        .push({
          name: "post-show",
          params: { slug: post.slug },
        })
        .catch((e) => {});

      // this.$router.push(`/noticias/${post.slug}`)
    },
    postTitle(title) {
      if (title.length >= 55) {
        return `${title.slice(0, 55)}...`;
      } else {
        return title;
      }
    },
  },
  computed: {
    ...mapState("protagonists", ["carousel"]),
    heightImage() {
      if (this.$vuetify.breakpoint.smAndDown) {
        return "190px";
      } else {
        return "306px";
      }
    },
    styleProtagonistImg() {
      if (this.$vuetify.breakpoint.smAndDown) {
        return "position: absolute; zindex: 1; bottom: 20px; left: 10px; height: 57px;";
      } else {
        return "position: absolute; zindex: 1; bottom: 45px; left: 20px;";
      }
    },
  },
};
</script>

